import React from "react";
import { Box, Typography } from "@mui/material";
import { footerBoxSx } from "./constants/buttonStyles";
import { copyrightText } from "@kivunova/kivufrontendcommon";

const SmallScreenFooter: React.FC = () => (
  <Box sx={footerBoxSx}>
    <Typography
      variant="caption"
      sx={{ textAlign: "center", width: "100%" }}
      data-testid="forgot-password-footer"
    >
      {copyrightText("Kivunova")}
    </Typography>
  </Box>
);

export default SmallScreenFooter;
